import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-multiple-select-chip',
  templateUrl: './multiple-select-chip.component.html',
  styleUrls: ['./multiple-select-chip.component.scss'],
})
export class MultipleSelectChipComponent implements OnInit {
  @ViewChild('inputElements') inputElements: ElementRef<HTMLInputElement>;

  @Input() label: string;
  @Input() required = false;
  @Input() inputBehavior: BehaviorSubject<InputSelectInterface[]>;
  @Input() placeholder: string;
  @Input() class?: string;
  @Input() resetOptions: (param: any) => void | boolean;

  @Output() dataFilter = new EventEmitter<string[]>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  valueFormGroup?: FormGroup;
  inputSelectInterfaces: InputSelectInterface[] = [];
  valueFormControl?: FormControl;
  dataOutput: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  isViewAll: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  STRING_CONSTANTS = STRING_CONSTANTS;

  constructor(private formGroupDirective: FormGroupDirective, private activeRoute: ActivatedRoute, private formControlNameDirective: FormControlName) {}

  ngOnInit(): void {
    this.valueFormGroup = this.formGroupDirective.form;
    this.valueFormControl = this.formGroupDirective.getControl(this.formControlNameDirective);

    this.dataOutput.subscribe((value) => {
      this.valueFormControl?.setValue(value);
      this.dataFilter.emit(value);
      if (value.length > 2) {
        this.isViewAll.next(false);
      }
    });

    this.checkQueryParam();
  }

  checkQueryParam() {
    this.activeRoute.queryParams.subscribe((data) => {
      if (Object.keys(data).length === 0) {
        if (this.inputSelectInterfaces.length) {
          this.resetOptionsTest();
        }
      }
    });
  }

  get controlName() {
    return this.formControlNameDirective.name;
  }

  get enabled() {
    return this.valueFormControl?.enabled;
  }

  onClickViewAll() {
    this.isViewAll.next(true);
  }

  checkActiveOptions(value: string): boolean {
    return !!this.inputSelectInterfaces.find((i) => i.value === value);
  }

  // onCheckboxChange(e: any) {}
  //
  // inputSearch = new FormGroup({
  //   search: new FormControl(''),
  // });
  //
  // changeInputSearch(e: any) {}

  selected($event: MatAutocompleteSelectedEvent) {
    const addItem = () => {
      this.inputSelectInterfaces.push($event.option.value);
      this.inputElements.nativeElement.value = '';
    };
    if (this.inputSelectInterfaces.length > 0) {
      if (this.inputSelectInterfaces.find((i) => i.value === $event.option.value.value)) {
        this.inputElements.nativeElement.value = '';
      } else {
        addItem();
      }
    } else {
      addItem();
    }
    this.setOutputData();
  }

  remove(inputSelectInterface: InputSelectInterface) {
    const index = this.inputSelectInterfaces.indexOf(inputSelectInterface);
    if (index >= 0) {
      this.inputSelectInterfaces.splice(index, 1);
      this.setOutputData();
      this.isViewAll.next(true);
    }
  }

  setOutputData() {
    let MainData: string[] = [];
    this.inputSelectInterfaces.map((e) => {
      if (e.value) {
        MainData.push(e.value);
      }
    });
    this.dataOutput.next(MainData);
  }

  resetOptionsTest() {
    this.inputSelectInterfaces = [];
    this.dataOutput.next([]);
  }
}
